// extracted by mini-css-extract-plugin
export var alertIcon = "_sm-0";